export const mapStateToProps = (
): any => {
  return {};
};
